/**
 * Reads where a slot is actually painted (for pop/fx at click time).
 * @param {HTMLElement | null} slotEl
 * @param {HTMLElement | null} boardEl
 * @returns {{ x: number, y: number } | null}
 */
export function readSlotCenterPercent(slotEl, boardEl) {
    if (!slotEl || !boardEl) return null;

    const board = boardEl.getBoundingClientRect();
    if (!board.width || !board.height) return null;

    const slot = slotEl.getBoundingClientRect();
    return {
        x: ((slot.left + slot.width / 2 - board.left) / board.width) * 100,
        y: ((slot.top + slot.height / 2 - board.top) / board.height) * 100,
    };
}

/**
 * Maps board-percent coordinates to a compositor-friendly transform.
 * @param {{ x: number, y: number, zIndex?: number, rotate?: number }} item
 * @param {{ width: number, height: number }} boardSize
 */
export function getItemSlotStyle(item, boardSize) {
    const width = boardSize.width;
    const height = boardSize.height;

    if (!width || !height) {
        return {
            left: `${item.x}%`,
            top: `${item.y}%`,
            transform: 'translate(-50%, -50%)',
            zIndex: item.zIndex ?? 4,
            '--lp-item-rotate': `${item.rotate ?? 0}deg`,
        };
    }

    const xPx = (item.x / 100) * width;
    const yPx = (item.y / 100) * height;

    return {
        zIndex: item.zIndex ?? 4,
        transform: `translate3d(${xPx}px, ${yPx}px, 0) translate(-50%, -50%)`,
        '--lp-item-rotate': `${item.rotate ?? 0}deg`,
    };
}
